import { render, staticRenderFns } from "./magazine-header.vue?vue&type=template&id=0b4c3c0a&scoped=true&"
import script from "./magazine-header.vue?vue&type=script&lang=js&"
export * from "./magazine-header.vue?vue&type=script&lang=js&"
import style0 from "./magazine-header.vue?vue&type=style&index=0&id=0b4c3c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c3c0a",
  null
  
)

export default component.exports